export default __webpack_public_path__ + "static/media/Check cr-fr.a8992c2c.svg";